exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 991px) {\n.pl-4[data-v-515bee64], .px-4[data-v-515bee64] {\n        padding-left: 1rem !important;\n}\n}\n", ""]);

// exports
